import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Plus, Menu, X, Check, Search, ChevronRight, Download } from 'lucide-react';
export function DesignSystem() {
  return <section className="py-24 px-6 md:px-12 border-b-2 border-navy bg-gray-50" id="system" data-id="element-86">
      <div className="max-w-7xl mx-auto" data-id="element-87">
        <div className="flex items-baseline justify-between mb-16 border-b-2 border-navy pb-4" data-id="element-88">
          <h2 className="text-4xl md:text-6xl font-bold text-navy tracking-tight" data-id="element-89">
            DESIGN SYSTEM
          </h2>
          <span className="font-mono text-sm text-coral" data-id="element-90">03 / COMPONENTS</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-91">
          {/* Typography Scale */}
          <div className="lg:col-span-6 space-y-8" data-id="element-92">
            <h3 className="font-mono text-sm text-navy/60 uppercase tracking-widest mb-8 border-b border-navy/20 pb-2" data-id="element-93">
              Typography Scale
            </h3>
            <div className="space-y-8" data-id="element-94">
              <div data-id="element-95">
                <span className="font-mono text-xs text-coral mb-1 block" data-id="element-96">
                  Display / Instrument Sans Bold
                </span>
                <p className="text-6xl md:text-7xl font-bold text-navy leading-[0.9]" data-id="element-97">
                  Aa Bb Cc
                </p>
              </div>
              <div data-id="element-98">
                <span className="font-mono text-xs text-coral mb-1 block" data-id="element-99">
                  Heading 2 / Instrument Sans SemiBold
                </span>
                <p className="text-4xl font-semibold text-navy" data-id="element-100">
                  The quick brown fox
                </p>
              </div>
              <div data-id="element-101">
                <span className="font-mono text-xs text-coral mb-1 block" data-id="element-102">
                  Body / Instrument Sans Regular
                </span>
                <p className="text-lg text-navy max-w-md" data-id="element-103">
                  Design is the method of putting form and content together.
                  Design, just as art, has multiple definitions; there is no
                  single definition.
                </p>
              </div>
              <div data-id="element-104">
                <span className="font-mono text-xs text-coral mb-1 block" data-id="element-105">
                  Mono / Space Mono
                </span>
                <p className="font-mono text-sm text-navy" data-id="element-106">
                  function generateBrand() &#123; return "identity" &#125;
                </p>
              </div>
            </div>
          </div>

          {/* UI Elements */}
          <div className="lg:col-span-6 space-y-12" data-id="element-107">
            {/* Buttons */}
            <div data-id="element-108">
              <h3 className="font-mono text-sm text-navy/60 uppercase tracking-widest mb-8 border-b border-navy/20 pb-2" data-id="element-109">
                Interactive Elements
              </h3>
              <div className="flex flex-wrap gap-4" data-id="element-110">
                <button className="bg-coral text-white px-6 py-3 font-bold border-2 border-coral hover:bg-navy hover:border-navy transition-colors" data-id="element-111">
                  PRIMARY BUTTON
                </button>
                <button className="bg-transparent text-navy px-6 py-3 font-bold border-2 border-navy hover:bg-navy hover:text-white transition-colors" data-id="element-112">
                  SECONDARY
                </button>
                <button className="text-navy px-6 py-3 font-bold hover:text-coral transition-colors flex items-center gap-2" data-id="element-113">
                  GHOST LINK <ArrowRight className="w-4 h-4" data-id="element-114" />
                </button>
              </div>
            </div>

            {/* Icons Grid */}
            <div data-id="element-115">
              <h3 className="font-mono text-sm text-navy/60 uppercase tracking-widest mb-8 border-b border-navy/20 pb-2" data-id="element-116">
                Iconography
              </h3>
              <div className="grid grid-cols-4 gap-px bg-navy/10 border border-navy/10" data-id="element-117">
                {[ArrowRight, Plus, Menu, X, Check, Search, ChevronRight, Download].map((Icon, i) => <div key={i} className="bg-white p-6 flex items-center justify-center hover:bg-coral/10 transition-colors" data-id="element-118">
                    <Icon className="w-6 h-6 text-navy" data-id="element-119" />
                  </div>)}
              </div>
            </div>

            {/* Spacing */}
            <div data-id="element-120">
              <h3 className="font-mono text-sm text-navy/60 uppercase tracking-widest mb-8 border-b border-navy/20 pb-2" data-id="element-121">
                Spacing Units
              </h3>
              <div className="flex items-end gap-2 h-32" data-id="element-122">
                {[4, 8, 16, 24, 32, 48, 64].map(size => <div key={size} className="group relative flex flex-col items-center gap-2" data-id="element-123">
                    <motion.div className="w-8 bg-coral/20 border border-coral group-hover:bg-coral transition-colors" style={{
                  height: size
                }} whileHover={{
                  scale: 1.1
                }} data-id="element-124" />
                    <span className="font-mono text-xs text-navy/60" data-id="element-125">
                      {size}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}